import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-last-updated',
  templateUrl: './last-updated.component.html',
  styleUrls: ['./last-updated.component.css']
})
export class LastUpdatedComponent implements OnInit {

  @Input() lastUpdatedSetting: string = '';

  constructor() {
  }

  ngOnInit(): void {
  }
}
